import { render, staticRenderFns } from "./iconBoxView.vue?vue&type=template&id=41eabe2c&scoped=true"
import script from "./iconBoxView.vue?vue&type=script&lang=js"
export * from "./iconBoxView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41eabe2c",
  null
  
)

export default component.exports